import type { Credential } from "../types";
import { blankCredentialInstance } from "./blank-credential-instance";

type ReviewTarget = {
  documentId: string;
  targetCredentialId: string | null;
  candidate: {
    matchedCredentialId: string | null;
    credentialType: string;
  } | null;
};

/** Resolve the exact target or a new instance; never guess a same-type holding. */
export function credentialReviewTarget({
  item,
  credentials,
}: {
  item: ReviewTarget;
  credentials: Credential[];
}): Credential | null {
  if (item.targetCredentialId) {
    return (
      credentials.find((row) => row.credentialId === item.targetCredentialId) ??
      null
    );
  }
  if (item.candidate?.matchedCredentialId) {
    return (
      credentials.find(
        (row) => row.credentialId === item.candidate?.matchedCredentialId,
      ) ?? null
    );
  }
  const parsedType = item.candidate?.credentialType;
  if (!parsedType) {
    return null;
  }
  const template = credentials.find((row) => row.credentialType === parsedType);
  if (!template) {
    return null;
  }
  return blankCredentialInstance(template, `review:${item.documentId}`);
}
